import api from 'api';

export default function deleteWorker(workerId: string) {
  return api.delete(`workers/${workerId}`);
}
